import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "#fff",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_6692",
		"data-name": "Path 6692",
		d: "M4.25,5.61C6.57,8.59,10,13,10,13v5a2.006,2.006,0,0,0,2,2h0a2.006,2.006,0,0,0,2-2V13s3.43-4.41,5.75-7.39A1,1,0,0,0,18.95,4H5.04A1,1,0,0,0,4.25,5.61Z",
		transform: "translate(-4.038 -4)"
	})
});
export { SvgIconFilter as ReactComponent };
